export default __webpack_public_path__ + "ed7dd80051afbe91aa26343e1be1ad3e.png";